<template>
  <v-dialog v-model="dialog" persistent max-width="600px" fullscreen>
    <template v-slot:activator="{ on }">
      <v-icon depressed v-on="on">filter_alt</v-icon>
    </template>
    <v-card>
      <v-toolbar dense class="elevation-0 amber darken-1 white--text py-auto">
        <v-toolbar-title class="ml-3">Lọc Tìm Kiếm</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <lead-filter @onFilterChanged="onFilterChanged"></lead-filter>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LeadFilter from '@/modules/lead/LeadFilter.vue'

export default {
  components: { LeadFilter },
  props: {},
  data: () => ({
    dialog: false,
  }),
  methods: {
    cancel() {
      this.dialog = false
    },
    onFilterChanged(data) {
      this.dialog = false
      this.$emit('onFilter', data)
    },
  },
}
</script>
<style scoped>
</style>
